import { IcCalendarIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IPopoverMenuItem } from '@gem/ui-kit';

import { Features } from 'APP/packages/features/Features';

export interface IMediaMessageSubmitMenuParams {
  onSubmit(isScheduled?: boolean): Promise<void>;
}

interface IMediaMessageSubmitMenuPresenter {
  isShow: boolean;
  menuItems: IPopoverMenuItem[];
}

export const useMediaMessageSubmitMenuPresenter = (
  params: IMediaMessageSubmitMenuParams
): IMediaMessageSubmitMenuPresenter => {
  const { onSubmit } = params;
  const { t } = useTranslation();

  const presenter = {
    get isShow(): boolean {
      return presenter.menuItems.length > 0;
    },

    get menuItems(): IPopoverMenuItem[] {
      const items = [
        {
          key: 'scheduleMessage',
          icon: IcCalendarIcon,
          title: t('schedule_message'),
          isVisible: Features.isScheduledMessagesEnabled(),
          onClick: () => onSubmit(true),
        },
      ];

      return items.filter((item) => item.isVisible);
    },
  };

  return presenter;
};
